import { Component, OnInit } from '@angular/core';
import { User } from '../_models/user';
import { AccessSecurity } from '../_models/accessSecurity';
import { Location } from '@angular/common';
@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.css']
})
export class HeaderComponent implements OnInit {
  public tabClicked: string = "dashboard";
  constructor(public user: User, public accessSec: AccessSecurity, public location: Location) {
    /*if(this.location.path().indexOf('dashboard')>-1 || this.location.path().indexOf('adminDashboard')>-1){
    this.tabClicked = 'dashboard';
    }else if(this.location.path().indexOf('myAccountList')>-1){
    this.tabClicked = 'myAccountList';
    }*/
    this.toggleLeftMenu();
    console.log(this.location.path().split('/'));
    this.tabClicked = this.location.path().split('/')[this.location.path().split('/').length - 1]
  }

  ngOnInit() { }

  populateTabData(triggered) {
    this.tabClicked = triggered;
    //if (this.tabClicked.indexOf('active') >= 0) {

    // } else {
    //  this.tabClicked = triggered + '-active';
    // }
  }

  toggleLeftMenu() {
    var classValue = document.getElementById('mainBody').className;
    if (classValue == '') {
      document.getElementById('mainBody').className = 'menu-close';
    } else {
      document.getElementById('mainBody').className = '';
    }
  }

}


